import React from 'react';
import { Box, SxProps, Theme } from '@mui/material';

interface Props {
  /** Narrowest a column may get, in px; as many columns as fit, all the same width. */
  min?: number;
  gap?: number;
  sx?: SxProps<Theme>;
  children: React.ReactNode;
}

/**
 * Cards in even columns that wrap as the screen narrows. Use it instead of a wrapping flex row,
 * where the last card stretches across the whole line on its own.
 */
const AutoGrid: React.FC<Props> = ({ min = 220, gap = 2, sx, children }) => (
  <Box
    sx={[
      { display: 'grid', gap, gridTemplateColumns: `repeat(auto-fill, minmax(min(${min}px, 100%), 1fr))`, '& > *': { minWidth: 0 } },
      ...(Array.isArray(sx) ? sx : [sx]),
    ]}
  >
    {children}
  </Box>
);

export default AutoGrid;
